export default function TrustBar() {
  const items = [
    { icon: 'ri-refresh-line', label: 'Updated Daily Spreadsheets' },
    { icon: 'ri-database-2-line', label: '10,000+ Curated Items' },
    { icon: 'ri-verified-badge-line', label: 'Community Verified Finds' },
    { icon: 'ri-user-star-line', label: 'Beginner Friendly Guides' },
  ];

  return (
    <section className="bg-background-50 border-b border-background-200/60">
      <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 md:py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
          {items.map((item) => (
            <div key={item.label} className="flex items-center gap-2.5 md:gap-3 justify-center">
              <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center bg-accent-100 rounded-lg flex-shrink-0">
                <i className={`${item.icon} text-accent-600 text-sm md:text-base`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-700 whitespace-nowrap">
                {item.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}